/**
 * One shape for "the statements in an upload", whichever path produced them.
 *
 * The AI extraction path returns a single flat statement object; the camt.053
 * parser returns an envelope containing several. Mirrors
 * backend/bank_recon/services/extracted_statements.py -- keep the two in step.
 */

export const statementBlocks = (extractedData) => {
    if (!extractedData || typeof extractedData !== 'object') return [];
    if (Array.isArray(extractedData.statements)) return extractedData.statements;
    return [extractedData];
};

/**
 * Every transaction across every block, tagged with the block it came from.
 *
 * The review screen selects lines by index, so the flattened order here is what
 * `selectedLines` indexes into. Keep block order -- it is the order the bank
 * sent, and the operator reads it as a timeline.
 */
export const allStatementLines = (extractedData) =>
    statementBlocks(extractedData).flatMap((block, blockIndex) =>
        (block.lines || []).map(line => ({ ...line, blockIndex }))
    );

export const isMultiStatement = (extractedData) => statementBlocks(extractedData).length > 1;

/**
 * Was this read straight out of a machine-readable bank file?
 *
 * Drives the honesty of the review screen's heading: a camt.053 is parsed
 * exactly, with no AI in the loop, and calling that "AI-extracted" tells the
 * operator to double-check figures that cannot be wrong.
 */
export const isParsedFormat = (extractedData) =>
    !!extractedData && extractedData.format === 'camt.053';
